export enum UpdateDeviceMethod {
  Clear = 'CLEAR',
  Add = 'ADD',
  Delete = 'DELETE',
}

export enum PairedPage {
  FoundDevices = 'found_devices',
  ManuallyPaired = 'manually_paired',
}